import React from "react";
import InfoCard from "../../components/card/infocard";
import mmm from "../../assets/media2.png";
import PageIntroNav from "../../components/navigation/PageIntroNav";

const MediaDetails = () => {
  const openDeleteLevel = () => alert("iiiii");
  const openModal = () => alert("iiiii");
  return (
    <div className=" font-Outfit">
      <PageIntroNav
        breadcrumbs={[
          { label: "Company Settings", path: "/company-settings" },
          { label: "Media", path: "/company-settings/media" },
          { label: "Media Details" },
        ]}
        title="Media Details"
        subtitle="Media asset details and actions."
        fallbackPath="/company-settings/media"
        backLabel="Back to Media"
        actions={(
          <div className="flex items-center gap-3">
            <button
              onClick={openModal}
              className="border border-[#1234CD] text-[#1234CD] px-4 py-2 rounded-xl"
            >
              Edit
            </button>
            <button
              onClick={openDeleteLevel}
              className="border border-red-500 text-red-600 px-4 py-2 rounded-xl"
            >
              Delete
            </button>
          </div>
        )}
      />

      <InfoCard
        details="Media Details"
        title="MEDIA NAME"
        description="Lorem ipsum dolor sit amet consectetur. Tellus ut integer velit egestas mi pretium eu odio. Fames tellus consectetur urna sit euismod ipsum egestas in. Vulputate eget tortor risus sit. Pharetra mi tincidunt amet donec vitae ornare. Rhoncus lectus amet in risus consequat malesuada et. Sed et dolor quam lacus aenean sociis. Ullamcorper laoreet et ipsum ut eget. Ut amet purus lobortis tellus neque imperdiet. Tempus sagittis adipiscing amet sagittis ac.
        
      "
        // image={mmm}
        metaData={[{ label: "Date created", value: "11th April, 2024" }]}
        // image={HOD}
      >
        <div className="my-4">
          <img
            src={mmm}
            alt=""
          />
        </div>
      </InfoCard>
    </div>
  );
};

export default MediaDetails;
